var React = require('react');

function ReferencesIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Icon"},[React.createElement("path",{"d":"M21.5 35.833h12.375","transform":"translate(-5.05 -8.332)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":0}),React.createElement("path",{"data-name":"Path","d":"M23.938 6.012a2.917 2.917 0 1 1 4.125 4.125L10.875 27.325l-5.5 1.375 1.375-5.5z","transform":"translate(-1.3 -1.199)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":1})]));
}

ReferencesIcon.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33"};

module.exports = ReferencesIcon;

ReferencesIcon.default = ReferencesIcon;
